const DriverSteps = [
  {
    element: "#address",
    popover: {
      title: "Confirm/Change Address",
      description:
        "Service-Rendering will automatically detect your location, but you can change it by clicking on the address.",
      side: "right",
      align: "start",
    },
  },

  {
    element: "#nav",
    popover: {
      title: "Navigation Bar",
      description:
        "In the navigation bar, you can view your active or upcoming bookings by clicking the 'Booking' tab, check conversations with artisans via the 'Chats' tab, and access your profile through the 'Profile' tab",
      side: "right",
      align: "start",
    },
  },
  {
    element: "#notification",
    popover: {
      title: "Get Notifications",
      description:
        "Click here to view all your notifications and activities on Service-Rendering",
      side: "left",
      align: "start",
    },
  },
  {
    element: "#category",
    popover: {
      title: "Categories",
      description:
        "You can browse artisans by category—just click on any category you prefer.",
      side: "right",
      align: "start",
    },
  },
  {
    element: "#fix",
    popover: {
      title: "Fixed Of the month",
      description:
        "This is a special service with carefully selected artisans for you each month.Click on any to get more details.",
      side: "right",
      align: "start",
    },
  },
  {
    element: "#recommended",
    popover: {
      title: "Artisans close to you",
      description:
        "These are services from artisans near your location. Click on any to get more details.",
      side: "right",
      align: "start",
    },
  },
  {
    popover: {
      title: "Happy Fixing ",
      description:
        "And that's it! Go ahead and start booking services from your favorite artisans ASAP.",
    },
  },
];

export default DriverSteps;
